interface CardCategoryProps {
  title: string;
  text: string;
}

const CardCategory = ({ title, text }: CardCategoryProps) => (
  <div className="lc-min-h-[60px] lc-mb-4">
    <span className="lc-w-full lc-block lc-text-xs lc-mb-1 lc-uppercase">{title}</span>
    <span className="lc-w-full lc-block lc-text-xl lc-border-spacing-2">{text}</span>
  </div>
);

export default CardCategory;
